import { BaseSchema } from "./BaseSchema";
import { VariableType } from "./VariableType";

export abstract class BaseTypeSchema extends BaseSchema
{
    type: VariableType;
    required: boolean;
    valids: string[] = [];
    invalids: string[] = [];
    read_only: boolean = false;
    example?: string;
    protected constructor(type: VariableType, required: boolean)
    {
        super();
        this.type = type;
        this.required = required;
    }
    setRequired(required: boolean): BaseTypeSchema
    {
        this.required = required;
        return this;
    }
    getValids(): string[]
    {
        return this.valids;
    }
    setValid(...values: string[]): BaseTypeSchema
    {
        this.valids = values;
        return this;
    }
    addValid(...values: string[]): BaseTypeSchema
    {
        this.valids.push(...values);
        return this;
    }
    getInvalids(): string[]
    {
        return this.invalids;
    }
    setInvalid(...values: string[]): BaseTypeSchema
    {
        this.invalids = values;
        return this;
    }
    addInvalid(...values: string[]): BaseTypeSchema
    {
        this.invalids.push(...values);
        return this;
    }
}